import { ApproveApi } from '@/apis';
import { ApproveBike, ApproveCoupon } from '@/types/approve';
import { ResponseData } from '@/types/http';
import { TableState } from '@tanstack/react-table';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { ApproveBikeRequest, ApproveCouponRequest } from '@/types/http-payload/approve';

export default class ApproveStore extends BaseStore {
    approveBikeList: ApproveBike[] = [];
    approveCouponList: ApproveCoupon[] = [];
    api: ApproveApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            approveBikeList: observable,
            approveCouponList: observable,
            getAllBikeApprove: flow.bound,
            getResionByBikeId: flow.bound,
            approveBikes: flow.bound,
            getAllCouponApprove: flow.bound,
            approveCoupons: flow.bound

        });
        this.api = new ApproveApi();
    }

    *getAllBikeApprove(searchParams?: any, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getAllBikeApprove, payload);
            if (res.ok) {
                this.approveBikeList = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
                return res.data;
            }
        } catch (error) {
        }
    }

    *getResionByBikeId(bikeId: number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getResionByBikeId, bikeId);
            if (res?.ok) {
                return res?.data?.elements;
            }
            return false;
        } catch (error) {
        }
    }

    *approveBikes(payload: ApproveBikeRequest) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.approveBikes, payload);
            if (res?.ok) {
                return true;
            }
            return false;
        } catch (error) {
        }
    }

    *getAllCouponApprove(searchParams?: any, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getAllCouponApprove, payload);
            if (res.ok) {
                this.approveCouponList = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
                return res.data;
            }
        } catch (error) {
        }
    }

    *approveCoupons(payload: ApproveCouponRequest) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.approveCoupons, payload);
            if (res?.ok) {
                return true;
            }
            return false;
        } catch (error) {
        }
    }

    clean(): void {
        super.clean();

        this.approveBikeList = [];
        this.approveCouponList = [];
    }
}
